/**
 * Подарок к заказу (колпачок к фаркопу) Bitrix кладёт в корзину правилом
 * «Подарок»: строка со скидкой 100 %, отдельного признака в ответе нет.
 */
export function isGiftItem(item: any): boolean {
  return Number(item?.PRICE) === 0 && Number(item?.NO_DISCOUNT_PRICE) > 0;
}

/** Делит корзину на выбранные товары и подарки; итоги — без подарков. */
export function splitGifts(basket: any) {
  const allItems: any[] = basket?.ITEMS || [];
  const gifts = allItems.filter(isGiftItem);
  const giftsSum = (key: string) =>
    gifts.reduce((sum, item) => sum + Number(item[key] || 0), 0);

  return {
    items: allItems.filter((item) => !isGiftItem(item)),
    gifts,
    qty: Number(basket?.QTY || 0) - giftsSum("QUANTITY"),
    noDiscountPrice:
      Number(basket?.NO_DISCOUNT_PRICE || 0) -
      giftsSum("NO_DISCOUNT_PRICE_TOTAL"),
    discountPrice:
      Number(basket?.DISCOUNT_PRICE || 0) - giftsSum("DISCOUNT_PRICE_TOTAL"),
  };
}

/**
 * Строки, которые были подарком, а стали платными: Bitrix не убирает подарок
 * вместе с последним товаром, и колпачок остаётся в корзине за 100 руб.
 */
export function getLostGiftIds(prevBasket: any, nextBasket: any): number[] {
  const prevGiftIds = new Set(
    (prevBasket?.ITEMS || []).filter(isGiftItem).map((item: any) => item.ID),
  );
  return (nextBasket?.ITEMS || [])
    .filter((item: any) => prevGiftIds.has(item.ID) && !isGiftItem(item))
    .map((item: any) => item.ID);
}
